/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : hightman (hightman@cloud-sun.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import * as api from '@/api/user';
import { USER } from '@/store/types';
import { finalizeAction } from '@/store/actions';
import { UserFieldInfos } from '@/api/types/user';

export interface StoreUserFieldState {
  infos: UserFieldInfos;
  uid: number;
  field: string;
}

export default {
  namespaced: true,
  state: {
    infos: {},
    uid: null,
    field: null,
  },
  getters: {},
  actions: {
    [USER.GET_FIELD_INFOS]({ commit, state }, { action: rawAction, field, uid }) {
      const action = finalizeAction(rawAction, state.field === field && state.uid === uid);
      if (action) {
        return new Promise<void>((resolve, reject) => {
          api.getFieldInfos(field, uid).then((res) => {
            commit(USER.GET_FIELD_INFOS, {
              infos: res.data,
              uid,
              field,
            });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [USER.GET_FIELD_INFOS](state, { infos, uid, field }) {
      state.infos = infos;
      state.uid = uid;
      state.field = field;
    },
  },
};
